import type { ShortcutConfig } from '@ztechapps/webui.util'

export const ShortcutDefaults = {
  // General
  ShowHelp: { id: 'show-help', keys: 'shift+?', label: 'Show keyboard shortcuts', category: 'General' },
  FocusSearch: { id: 'focus-search', keys: 'ctrl+k', label: 'Focus search', category: 'General' },

  // Quick Create
  QuickCreateOrder: {
    id: 'quick-create-order',
    keys: 'ctrl+shift+o',
    label: 'Order from customer',
    category: 'Quick Create',
  },
  QuickCreateOrderFromConversation: {
    id: 'quick-create-order-zendesk',
    keys: 'ctrl+shift+z',
    label: 'Order from conversation',
    category: 'Quick Create',
  },
  QuickCreateProduct: { id: 'quick-create-product', keys: 'ctrl+shift+p', label: 'Product', category: 'Quick Create' },
  QuickCreateCustomer: {
    id: 'quick-create-customer',
    keys: 'ctrl+shift+u',
    label: 'Customer',
    category: 'Quick Create',
  },
  QuickCreatePurchase: {
    id: 'quick-create-purchase',
    keys: 'ctrl+shift+b',
    label: 'Purchase',
    category: 'Quick Create',
  },
  QuickCreateLogistics: {
    id: 'quick-create-logistics',
    keys: 'ctrl+shift+l',
    label: 'Logistics',
    category: 'Quick Create',
  },
  QuickCreateWorkorder: {
    id: 'quick-create-workorder',
    keys: 'ctrl+shift+w',
    label: 'Production',
    category: 'Quick Create',
  },
  QuickCreateProject: { id: 'quick-create-project', keys: 'ctrl+shift+j', label: 'Project', category: 'Quick Create' },
  QuickCreateTask: { id: 'quick-create-task', keys: 'ctrl+shift+d', label: 'Task', category: 'Quick Create' },
  QuickCreateAdjustment: {
    id: 'quick-create-adjustment',
    keys: 'ctrl+shift+a',
    label: 'Adjustment',
    category: 'Quick Create',
  },

  // Actions
  Delete: { id: 'delete', keys: 'ctrl+shift+backspace', label: 'Delete', category: 'Actions' },
  Clone: { id: 'clone', keys: 'ctrl+shift+c', label: 'Clone', category: 'Actions' },
  Refresh: { id: 'refresh', keys: 'ctrl+shift+r', label: 'Refresh', category: 'Actions' },
} as const satisfies Record<string, ShortcutConfig>

export const shortcutDefaults: ShortcutConfig[] = Object.values(ShortcutDefaults)
